import FalconCloseButton from 'components/common/FalconCloseButton';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import 'react-loading-skeleton/dist/skeleton.css';
import useToken from '../../hooks/useToken';
import { useToast } from 'context/providers/ToastProvider';

const ModalModulosPro = (
    {
        idLicencia,
        idCatTipoLicencia,
        setModulosProVinculados,
        setModulosExtraVinculados,
        showModalModuloPRO,
        setShowModalModuloPRO,
        setCargando
    }
) => {
    const [moduloPro, setModuloPro] = useState(0);
    const [ordenDetalleModulo, setOrdenDetalleModulo] = useState([]);
    const [modulosAkasiaPOS, setModulosAkasiaPOS] = useState([]);

    const [procesandoModal, setProcesandoModal] = useState(false);
    const { showErrorToast, showSuccessToast } = useToast();
    /**
     * AUTENTICACION
     */
    const { token, setToken } = useToken();
    /**
    * * activar un modulo pro
    * @param {any} e
    */
    const onSubmitAsignarModulo = async (e) => {
        e.preventDefault();
        if (setCargando) setCargando(true);

        //let idModuloExtra = 0;
        //// Validación de campos obligatorios
        //if (idCatTipoLicencia === 7) {
        //    if (!IdModuloAkasiaPos) {
        //        showErrorToast("Debes seleccionar el módulo antes de continuar.");
        //        return;
        //    }
        //    else if (!moduloPro) {
        //        showErrorToast("Debes seleccionar la orden antes de continuar.");
        //        return;
        //    }

        //    idModuloExtra = IdModuloAkasiaPos;

        //} else {
        if (!moduloPro) {
            showErrorToast("Debes seleccionar la orden antes de continuar.");
            return;
        }
        //}



        setProcesandoModal(true);
        const response = await fetch("/api/licencia/AsignarModulo/?id=" + idLicencia + "&od=" + moduloPro /*+ "&idModuloExtra=" + idModuloExtra*/, {
            method: 'PUT',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const data = await response.json();
            console.log(data);
            console.log(data);
            if (data["table1"][0].iResponseType == 1) {
                if (idCatTipoLicencia === 7) {
                    setModulosExtraVinculados(data["table2"]);
                }
                else {
                    setModulosProVinculados(data["table2"]);
                }
                showSuccessToast(data["table1"][0].vMessage);
            }
            else {
                showErrorToast(data["table1"][0].vMessage);
            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
        setShowModalModuloPRO(false);
        if (setCargando) setCargando(false);
        setProcesandoModal(false);
    };

    //OBTENER Lista de Modulos No vinculados
    const ObtenerListaOrdenDetalleModulo = async () => {
        if (setCargando) setCargando(true);

        const response = await fetch("/api/licencia/ObtenerListaOrdenDetalleModulo/?idLicencia=" + idLicencia, {
            method: 'GET',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const data = await response.json();
            setOrdenDetalleModulo(data);

            //Si la licencia es Akasia POS tambien busca los modulos extra para la licencia
            if (idCatTipoLicencia === 7) {


                const response = await fetch("/api/licencia/ObtenerListaModulosExtra/?idLicencia=" + idLicencia, {
                    method: 'GET',
                    headers:
                    {
                        'Authorization': 'Bearer ' + token,
                        'Content-Type': 'application/json'
                    }
                }).catch((error) => {
                    showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                    console.log('Hubo un problema con la peticion Fetch:' + error);
                });

                if (response.ok) {
                    const data = await response.json();
                    console.log(data);

                    setModulosAkasiaPOS(data);


                }
                else {
                    showErrorToast(response.status + ' ' + response.statusText);
                    console.log(response);
                    if (response.status == 401) {
                        setToken(null);
                        location.href = "";
                    }
                }
            }

        }

        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
        if (setCargando) setCargando(false);
    };



    return (
        showModalModuloPRO &&
        <Modal
            show={showModalModuloPRO}
            onHide={() => {
                setShowModalModuloPRO(false);
                if (setCargando) setCargando(false);
            }}
            onShow={() => ObtenerListaOrdenDetalleModulo()}
            size="md"
            backdrop="static"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Form noValidate onSubmit={onSubmitAsignarModulo}>
                <Modal.Header>
                    <Modal.Title>
                        {idCatTipoLicencia === 7 ? <>Activar Módulo Extra</> : <>Activar Módulo PRO | LIC #{idLicencia}</>}
                    </Modal.Title>
                    <FalconCloseButton className="btn btn-circle btn-sm transition-base p-0" onClick={() => {
                        setShowModalModuloPRO(false);
                        if (setCargando) setCargando(false);
                    }} />

                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col md={12}>
                            <Form.Group className="mb-3" >

                                <Form.Label>Selecciona la orden del pago del m&oacute;dulo</Form.Label>
                                <Form.Select
                                    required
                                    aria-label="Default select"
                                    onClick={(e) => setModuloPro(e.target.value)}
                                >
                                    <option value="">Selecciona la orden</option>
                                    {ordenDetalleModulo.map((od, index) => {
                                        return (<option key={index} value={od.idOrdenDetalle}>{od.vCodigoBarras} - Odn #{od.idOrden} - {od.dFechaVenta} - {parseFloat(od.dPrecioUnitarioImpuestos).toLocaleString("es-MX", {
                                            maximumFractionDigits: 2,
                                            minimumFractionDigits: 2,
                                            style: 'currency', currency: 'MXN'
                                        })} {od.vMoneda}</option>)
                                    })}
                                </Form.Select>

                                {idCatTipoLicencia === 7 ?
                                    <>
                                        <Form.Label className="mt-4">Selecciona el m&oacute;dulo extra para la licencia</Form.Label>
                                        <Form.Select
                                            required={idCatTipoLicencia === 7}
                                            aria-label="Default select"
                                        >
                                            <option value="">Selecciona el m&oacute;dulo</option>
                                            {modulosAkasiaPOS.map((mod, index) => {
                                                return (
                                                    <option key={index} value={mod.idCatModuloLicPOSWeb}>
                                                        {mod.vDescripcionModulo} ({mod.vCodigoModulo})
                                                    </option>
                                                );
                                            })}
                                        </Form.Select>
                                    </> :
                                    <>
                                    </>}

                                <Form.Control.Feedback type="invalid">

                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => { setShowModalModuloPRO(false); }} variant='primary' >Cerrar</Button>
                    {procesandoModal ? <Button variant="primary" disabled>
                        <Spinner
                            as="span"
                            animation="grow"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                        />
                        Procesando...
                    </Button> : <Button type="submit" variant='success' >A C T I V A R</Button>}
                </Modal.Footer>
            </Form>
        </Modal>

    )
}

ModalModulosPro.propTypes = {
    idLicencia: PropTypes.number,
    idCatTipoLicencia: PropTypes.number,
    setModulosProVinculados: PropTypes.func,
    setModulosExtraVinculados: PropTypes.func,
    showModalModuloPRO: PropTypes.bool,
    setShowModalModuloPRO: PropTypes.func,
    setCargando: PropTypes.func,
};


export default ModalModulosPro;
